import React, { useContext } from 'react';
import { AuthStateType } from '../components/authentication/utils';

export interface AuthContextValue {
  authConfig: any,
  authState: AuthStateType,
  user: any
}
export const AuthContext = React.createContext<AuthContextValue>(undefined);

interface AuthProviderProps {
  value: AuthContextValue,
  children: React.ReactNode
}

export const AuthProvider = ({ children, value }: AuthProviderProps) => {
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within a AuthProvider');
  }
  return context;
}
